import { render, staticRenderFns } from "./EconomicActivities.vue?vue&type=template&id=bc2f929e&scoped=true&"
import script from "./EconomicActivities.vue?vue&type=script&lang=js&"
export * from "./EconomicActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2f929e",
  null
  
)

export default component.exports